import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormContainer,
  LaurenQuoteMobile,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  RadioInput,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import {
  Length,
  postpartumOption,
  pregnantOption,
  pursuingPreservationOption,
} from "~/OnboardingApp/utils";
import { messages } from "~/utils/validations";

interface Values {
  lengthOfTimeTtc: Length;
}

const values: Length[] = [
  "Less than 6 months",
  "6-12 months",
  "1-2 years",
  "2-5 years",
  "5+ years",
  pregnantOption,
  postpartumOption,
  pursuingPreservationOption,
];

const validationSchema = Yup.object({
  lengthOfTimeTtc: Yup.string().oneOf(values).required(messages.required),
});

export const HowLongPage: FC = () => {
  const { t } = useTranslation();
  const { onSubmit } = useSubmitOnboardingQuestion();
  const { lengthOfTimeTtc } = useOnboarding();

  const initialValues: Values = {
    lengthOfTimeTtc: lengthOfTimeTtc || "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  const commentCopy = t("onboarding.howLongPage.comment");

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt
            comment={commentCopy}
            question={t("onboarding.howLongPage.question")}
          />
          {commentCopy && (
            <LaurenQuoteMobile initialShow>{commentCopy}</LaurenQuoteMobile>
          )}

          <RadioInput
            autoAdvance
            id="lengthOfTimeTtc"
            values={values}
            defaultValue={lengthOfTimeTtc}
          />
        </QuestionContainer>

        <NextButton showButton={!!lengthOfTimeTtc} />
      </FormContainer>
    </QuestionPageContainer>
  );
};
